import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { Programs, Products, Features, Flows, AgeLimits, Feature } from 'bff/models/product';
import { Activities, Codes, Bulletin, Inscats, Inscat, Activity } from 'bff/models/info';
import { TravelProdLink, Links } from 'bff/models/link';
import { InsType } from 'constants/enums/insType.enum';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { BulletinType } from 'constants/enums/bulletinType.enum';
import { TravelInsHome } from 'constants/models/components/travelInsHome';
import _ from 'lodash';

/**
 * @description 取得旅平險商品首頁初始化資料
 * @param programId 專案代碼
 */
const fetchInitSetting = async (programId:string): Promise<TravelInsHome> => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const programIdReq = commonService.getApiReqData({ PROGRAM_ID: programId || '' });

  const result:TravelInsHome = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchProgramByInsTypeId(programIdReq, reqConfig, InsType.Travel),
    apiService.fetchProductByInsTypeId(baseReq, reqConfig, InsType.Travel),
    apiService.fetchFeatureByInsTypeId(baseReq, reqConfig, InsType.Travel),
    apiService.fetchFlowByInsTypeId(baseReq, reqConfig, InsType.Travel),
    apiService.fetchAgeLimitByInsTypeId(baseReq, reqConfig, InsType.Travel),
    apiService.fetchActivitiesByInsTypeId(baseReq, reqConfig, InsType.Travel),
    apiService.fetchLinkByCategory(baseReq, reqConfig, InsType.Travel),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.CREDITCARD_BANK),
    apiService.fetchAnnounces(baseReq, reqConfig, BulletinType.InsType, InsType.Travel),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([
    inscatsRes, programsRes, productsRes, featuresRes, flowsRes,
    ageLimitsRes, activitiesRes, serviceLinksRes, creditCardCodeRes, bulletinRes,
    UICodeRes]) => {
    const inscatsBaseRes:BaseRes<Inscats> = { ...inscatsRes };
    const inscatRes = _.find(inscatsBaseRes.TRANRS.INSURANCE_CATEGORY, (inscat:Inscat) => inscat.INS_TYPE_ID === InsType.Travel) as Inscat;
    const programsBaseRes:BaseRes<Programs> = { ...programsRes };
    const productsBaseRes:BaseRes<Products> = { ...productsRes };
    const featuresBaseRes:BaseRes<Features> = { ...featuresRes };
    const flowsBaseRes:BaseRes<Flows> = { ...flowsRes };
    const ageLimitsBaseRes:BaseRes<AgeLimits> = { ...ageLimitsRes };
    const activitiesBaseRes:BaseRes<Activities> = { ...activitiesRes };
    const serviceLinksBaseRes:BaseRes<Links<TravelProdLink>> = { ...serviceLinksRes };
    const creditCardCodeBaseRes:BaseRes<Codes> = { ...creditCardCodeRes };
    const bulletinBaseRes:BaseRes<Bulletin> = { ...bulletinRes };
    const UICodeBaseRes:BaseRes<Codes> = { ...UICodeRes };

    const res:TravelInsHome = {
      inscat: { ...inscatRes },
      programs: commonService.arrayTypeReturn(programsBaseRes.TRANRS.PROGRAMS),
      products: commonService.arrayTypeReturn(productsBaseRes.TRANRS.PRODUCT),
      features: featuresBaseRes.TRANRS.FEATURE ? [...featuresBaseRes.TRANRS.FEATURE.sort((first:Feature, second:Feature) => first.SHOW_ORDER - second.SHOW_ORDER)] : new Array(0),
      flows: commonService.arrayTypeReturn(flowsBaseRes.TRANRS.FLOWS),
      ageLimits: { ...ageLimitsBaseRes.TRANRS },
      activities: {
        MORE_ACTIVITY_URL: activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL ? activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL : '',
        ACTIVITY: activitiesBaseRes.TRANRS.ACTIVITY ? [...activitiesBaseRes.TRANRS.ACTIVITY.sort((first:Activity, second:Activity) => +first.SHOW_ORDER - +second.SHOW_ORDER)] : new Array(0)
      },
      serviceLinks: serviceLinksBaseRes.TRANRS.LINKS ? [...serviceLinksBaseRes.TRANRS.LINKS.I01] : new Array(0),
      creditCardCode: commonService.arrayTypeReturn(creditCardCodeBaseRes.TRANRS.CODES),
      bulletin: bulletinBaseRes.TRANRS.BULLETIN ? { ...bulletinBaseRes.TRANRS } : { BULLETIN: {} } as Bulletin,
      UICode: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES),
      programId: ''
    };

    return res;
  });

  return result;
};

export default {
  fetchInitSetting
};
